var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "prop-types", "react", "classnames", "../../propTypes", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArrowRight", "../ImageWithLegend/ImageWithLegend"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("prop-types"), require("react"), require("classnames"), require("../../propTypes"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArrowRight"), require("../ImageWithLegend/ImageWithLegend"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.propTypes, global.react, global.classnames, global.propTypes, global.ArrowLeft, global.ArrowRight, global.ImageWithLegend);
    global.Carousel = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _propTypes, _react, _classnames, _propTypes2, _ArrowLeft, _ArrowRight, _ImageWithLegend) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArrowRight = _interopRequireDefault(_ArrowRight);
  _ImageWithLegend = _interopRequireDefault(_ImageWithLegend);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var NextArrow = function NextArrow(_ref) {
    var label = _ref.label,
        onClick = _ref.onClick;
    return /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": label,
      className: "article-carousel__next",
      onClick: onClick,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_ArrowRight.default, null));
  };

  NextArrow.propTypes = {
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var label = _ref2.label,
        onClick = _ref2.onClick;
    return /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": label,
      className: "article-carousel__prev",
      onClick: onClick,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, null));
  };

  PrevArrow.propTypes = {
    label: _propTypes.default.string,
    onClick: _propTypes.default.func
  };

  var Carousel = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(Carousel, _PureComponent);

    var _super = _createSuper(Carousel);

    function Carousel(props) {
      var _this;

      (0, _classCallCheck2.default)(this, Carousel);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTransitionEnd", function (event) {
        if (event.propertyName !== 'transform') {
          return;
        }

        if (_this.state.selectedSlide > -1 && _this.state.selectedSlide < _this.props.slides.length) {
          _this.focusSlide();
        }

        if (_this.state.selectedSlide === -1) {
          _this.setState({
            selectedSlide: _this.props.slides.length - 1,
            animate: false
          }, function () {
            _this.setState({
              animate: true
            });

            _this.focusSlide();
          });
        }

        if (_this.state.selectedSlide === _this.props.slides.length) {
          _this.setState({
            selectedSlide: 0,
            animate: false
          }, function () {
            _this.setState({
              animate: true
            });

            _this.focusSlide();
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchStart", function (_ref3) {
        var touches = _ref3.touches;
        _this.touchStartX = touches[0].pageX;
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchEnd", function (_ref4) {
        var changedTouches = _ref4.changedTouches;
        var direction = changedTouches[0].pageX - _this.touchStartX;

        if (Math.abs(direction) > 10) {
          if (direction < 0) {
            _this.onNextArrowClick();
          } else {
            _this.onPrevArrowClick();
          }
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPrevArrowClick", function () {
        if (_this.state.selectedSlide >= 0) {
          _this.setState(function (_ref5) {
            var selectedSlide = _ref5.selectedSlide;
            return {
              selectedSlide: selectedSlide - 1
            };
          }, function () {
            return _this.focusSlide();
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNextArrowClick", function () {
        if (_this.state.selectedSlide < _this.props.slides.length) {
          _this.setState(function (_ref6) {
            var selectedSlide = _ref6.selectedSlide;
            return {
              selectedSlide: selectedSlide + 1
            };
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTabIndex", function (slides, selectedSlide, index) {
        return _this.state.selectedSlide === index || _this.state.selectedSlide === index + _this.props.slides.length || _this.state.selectedSlide + _this.props.slides.length === index ? '0' : '-1';
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusSlide", function () {
        var selectedSlide = _this.state.selectedSlide;

        if (_this.root) {
          if (selectedSlide < _this.props.slides.length && selectedSlide > -1) {
            var selector = "div.article-carousel__slide[data-selected-slide=\"".concat(selectedSlide, "\"]");

            _this.root.querySelector(selector).focus();
          }
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      _this.touchStartX = 0;
      _this.state = {
        selectedSlide: 0,
        animate: true
      };
      return _this;
    } // infinite sliding handling:
    // we are on the last slide's clone => go back to the real last slide without animation
    // we are on the first slide's clone => go back to the real first slide without animation


    (0, _createClass2.default)(Carousel, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            labels = _this$props.labels,
            slides = _this$props.slides;
        var selectedSlide = this.state.selectedSlide;
        var translatePercentX = -(selectedSlide + 1) * 100;
        var countSlides = slides.length;
        return /*#__PURE__*/_react.default.createElement("div", {
          onTouchStart: this.onTouchStart,
          onTouchEnd: this.onTouchEnd,
          className: "article-carousel"
        }, /*#__PURE__*/_react.default.createElement(PrevArrow, {
          label: labels.getPrevImage,
          onClick: this.onPrevArrowClick
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "article-carousel__wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('article-carousel__inner', {
            'is-animated': this.state.animate
          }),
          style: {
            transform: "translateX(".concat(translatePercentX, "%)")
          },
          onTransitionEnd: this.onTransitionEnd,
          ref: this.init
        }, countSlides && /*#__PURE__*/_react.default.createElement("div", {
          className: "article-carousel__slide",
          key: "slide-last-clone"
        }, /*#__PURE__*/_react.default.createElement(_ImageWithLegend.default, this.props.slides[countSlides - 1])), this.props.slides.map(function (slide, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "article-carousel__slide",
            "data-selected-slide": index,
            key: "slide-".concat(index),
            tabIndex: _this2.getTabIndex(_this2.props.slides, _this2.state.selectedSlide, index)
          }, /*#__PURE__*/_react.default.createElement(_ImageWithLegend.default, slide));
        }), countSlides && /*#__PURE__*/_react.default.createElement("div", {
          className: "article-carousel__slide",
          key: "slide-first-clone"
        }, /*#__PURE__*/_react.default.createElement(_ImageWithLegend.default, this.props.slides[0])))), /*#__PURE__*/_react.default.createElement(NextArrow, {
          label: labels.getNextImage,
          onClick: this.onNextArrowClick
        }));
      }
    }]);
    return Carousel;
  }(_react.PureComponent);

  Carousel.propTypes = {
    labels: _propTypes.default.shape({
      getNextImage: _propTypes.default.string,
      getPrevImage: _propTypes.default.string
    }),
    slides: _propTypes.default.arrayOf(_propTypes.default.shape({
      copyright: _propTypes.default.string,
      images: _propTypes.default.arrayOf(_propTypes2.default.image).isRequired,
      title: _propTypes.default.string
    }))
  };
  Carousel.defaultProps = {
    labels: {
      getNextImage: 'Next image',
      getPrevImage: 'Previous image'
    },
    slides: []
  };
  var _default = Carousel;
  _exports.default = _default;
});